const PLURAL_RULES = new Intl.PluralRules('en-US', { type: 'ordinal' });

const SUFFIXES = new Map([
  ['one', 'st'],
  ['two', 'nd'],
  ['few', 'rd'],
  ['other', 'th']
]);

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules/PluralRules
const formatOrdinals = (number: number) => {
  const rule = PLURAL_RULES.select(number);
  const suffix = SUFFIXES.get(rule);
  return `${number}${suffix}`;
};

export { formatOrdinals };
